module.exports = __webpack_public_path__ + "static/media/Weapon_04_2.a30de947.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/WeaponComponent/Weapon_04_2.png
// module id = 1385
// module chunks = 0